<template>
  <div
    class="cpt-game-selector"
    :class="{ active: isSelected, nominee: isNominee }"
  >
    <div class="game-outer-box">
      <img
        v-if="isSelected"
        class="selected-icon"
        v-src="
          'https://imgheybox.max-c.com/oa/2024/11/06/17fff3ad46a4361a564ed3b683a3d4b0.png'
        "
      />
      <!-- <div class="game-online-count">
        {{ voteCount | numberFormat }}<span>票</span>
      </div> -->
      <div class="game-inner-box">
        <div class="game-image">
          <img class="image" v-src="game.img" alt="" />
        </div>
      </div>
    </div>
    <div class="game-name">
      <div class="text">{{ game.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    game: {
      type: Object,
      default: () => {},
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isNominee: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    voteCount() {
      return this.game.num || 0;
    },
  },
  filters: {
    numberFormat: function (num) {
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + 'w';
      }
      return num.toString();
    },
  },
};
</script>

<style lang="less">
.cpt-game-selector {
  width: 33.333333%;
  float: left;
  padding-right: 12px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &.active {
    .game-outer-box {
      .game-inner-box {
        border-color: #3366ca;
        .game-image {
          img {
            filter: grayscale(0);
          }
        }
      }
    }
    .game-name {
      background: #3366ca;
      .text {
        color: #fff;
      }
    }
  }
  &.nominee {
    .game-outer-box {
      .game-inner-box {
        .game-image {
          img {
            filter: grayscale(0);
          }
        }
      }
    }
  }
  .game-outer-box {
    width: 100%;
    padding-top: 150.476%;
    position: relative;
    flex: 0;
    .selected-icon {
      position: absolute;
      top: 11px;
      right: 10px;
      width: 16px;
      height: 16px;
      z-index: 2;
    }
    .game-online-count {
      height: 17px;
      background: #232425;
      border-radius: 2px;
      position: absolute;
      right: 3px;
      bottom: 3px;
      padding: 0 3px;
      line-height: 17px;

      color: rgba(255, 255, 255, 0.6);
      font-family: 'Gellix';
      font-size: 10px;
      font-weight: 600;
      z-index: 2;
      span {
        color: rgba(255, 255, 255, 0.6);
        font-family: 'PingFang SC';
        font-size: 10px;
        transform: scale(0.9);
        transform-origin: center;
      }
    }
    .game-inner-box {
      width: 200%;
      height: 200%;
      position: absolute;
      top: 0;
      left: 0;
      transform: scale(0.5);
      transform-origin: top left;
      border: 1px solid #232425;
      display: flex;
      flex-direction: column;
      border-radius: 6px 6px 0 0;
      overflow: hidden;
      z-index: 1;
      .game-image {
        width: 100%;
        padding-top: 150.96154%;
        position: relative;
        .tags-wrapper {
          width: 100%;
          height: 32px;
          padding: 0 16px;
          position: absolute;
          top: 16px;
          right: 0;
          display: flex;
          justify-content: flex-end;
          img {
            width: 32px;
            height: 32px;
            display: block;
            margin-left: 8px;
          }
        }
        .image {
          width: 100%;
          height: 100%;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          filter: grayscale(100%);
          transition: all 0.35s cubic-bezier(0.42, 0, 0.58, 1);
          object-fit: cover;
          &.is_people {
            filter: grayscale(0);
          }
        }
      }
    }
  }
  .game-name {
    flex: 1;
    height: 0;
    min-height: 32px;
    width: 100%;
    border-radius: 0 0 3px 3px;
    padding: 4px 7px 5px;
    background: #232425;
    display: flex;
    align-items: center;
    justify-content: center;
    .text {
      color: #e0e0e0;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 12px;
      line-height: 16px;
    }
  }
}
</style>
